/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import { Row, Col, Button, Table } from "react-bootstrap";

import { Categories } from "../../engine/categories";


export default function MonthDetailsPane(props) {
  const navigate = useNavigate();
  const sim_model = props.results.simResults.simModel;
  const timespan = props.results.simResults.timeSpan;
  const categories = sim_model.summary; // TODO rename summaries as categories
  let acct = props.simAcct || null;

  const [isYearGroup, setIsYearGroup] = useState(true);
  const [colGroups, setColGroup] = useState(createColumnGroups(sim_model, timespan.timeline, isYearGroup ? 1 : 2));
  const [catGroups, setCatGoups] = useState(createCategoryGroups(sim_model));
  const [dataRows, setDataRows] = useState(defineDataRows(catGroups, categories, acct));


  useEffect(() => {
    let groups = createColumnGroups(sim_model, timespan.timeline, isYearGroup ? 1 : 2);

    setColGroup(groups);
  }, [isYearGroup, catGroups, props.results]
  );

  useEffect(() => {
    let row_defs = defineDataRows(catGroups, categories, acct);
    fillGrid(colGroups, row_defs, acct);

    setDataRows(row_defs);

  }, [colGroups]
  );


  function handleGroupToggle(event) {
    event.preventDefault();

    setIsYearGroup(!isYearGroup);
  }


  function handleExpendColGroups(event) {
    event.preventDefault();

    let groups = colGroups.map(g => ({ ...g, isOpen: true, totals: [] }));
    setColGroup(groups);
  }


  function handleCollapseColGroups(event) {
    event.preventDefault();

    let groups = colGroups.map(g => ({ ...g, isOpen: false, totals: [] }));
    setColGroup(groups);
  }


  function handleColGroupToggle(event) {
    event.preventDefault();

    let groups = colGroups.map(g => ({ ...g, isOpen: g.htmlId !== event.currentTarget.id ? g.isOpen : !g.isOpen, totals: [] }));
    setColGroup(groups);
  }


  function handleRowGroupToggle(event) {
    event.preventDefault();

    let groups = catGroups.map(g => g.htmlId !== event.currentTarget.id ? g : { ...g, showGroup: !g.showGroup });
    setCatGoups(groups);
  }


  function onSelectMonth(index) {
    //let path = `/app/planner/accounts/${acct.baseID}/calendar?year=${year}&month=${month}`;
    let path = `/app/planner/accounts/${acct.baseID}/calendar?index=${index}`;
    navigate(path);

    //     props.onMonthClick(cell.data.index);
  }


  let div_style = {
    overflow: "scroll"
  }

  let table_style = {
    fontSize: ".7rem"
  }


  return (
    <div>
      <div>
        <button onClick={handleGroupToggle}>{isYearGroup ? 'Periods' : 'Years'}</button>
        <button onClick={handleExpendColGroups}>Expand</button>
        <button onClick={handleCollapseColGroups}>Collapse</button>
      </div>

      <div style={div_style}>
        <Table style={table_style} size="sm" bordered>
          <tbody>
            <GroupColumns isYearGroup={isYearGroup} groups={colGroups} onToggle={handleColGroupToggle} />
            <GroupMonths isYearGroup={isYearGroup} groups={colGroups} />
            {dataRows.map((d, i) => <DataRow key={i} row={d} onToggle={handleRowGroupToggle} />)}
          </tbody>
        </Table>

      </div>

    </div>
  );
}
//            {dataRows.map((d, i) => <DataRow key={i} row={d} onToggle={handleRowGroupToggle} />)}


//---------------------------------------------------------------------------------------
//
//---------------------------------------------------------------------------------------


function GroupColumns(props) {

  function Group(props) {
    let span = props.group.isOpen ? props.group.columns.length + 1 : 1;

    let group_header_style = {
      textAlign: "center",
      fontWeight: "bold"

    }


    return (
      <td style={group_header_style} colSpan={span}>
        {props.group.label}
        <span id={props.group.htmlId} onClick={props.onToggle}>{props.group.isOpen ? getIcon("left") : getIcon("right")}</span>
      </td>
    )
  }


  let label_col_style = {
    minWidth: "160px",
  }

  return (
    <tr>
      <td style={label_col_style}><strong>{props.isYearGroup ? 'Years' : 'Periods'}</strong></td>
      {props.groups.map(g => <Group key={g.id} group={g} onToggle={props.onToggle} />)}
    </tr>
  )

}


function GroupMonths(props) {

  function Months(mprops) {

    let group_header_style = {
      textAlign: "right",
    }

    return (
      <>
        {mprops.group.isOpen && mprops.group.columns.map(m => <td>{m.monthLabel}</td>)}
        <td>Total</td>
      </>
    )
  }


  return (
    <tr>
      <td><strong>Month</strong></td>
      {props.groups.map(g => <Months key={g.id} group={g} />)}
    </tr>
  );
}


function DataRow(props) {

  let icon = null;
  if (props.row.type === 'catgroup') {
    icon = props.row.isOpen ? getIcon("up") : getIcon("down");
  }


  let label_col_style = {
//    minWidth: "160px",
  }

  let default_cell_style = {
    textAlign: "right"
  }

  let cat_label_style = {
    display: "inline-block",
    paddingLeft: props.row.type === 'cat' ? "10px" : "0px"
  }

  return (
    <tr>
      <td style={label_col_style}>
        <span style={cat_label_style}>{props.row.label}</span>
        <ICon row={props.row} onClick={props.onToggle} />
      </td>
      {props.row.data.map((d, i) => <td key={i} style={default_cell_style}>{formatCell(d)}</td>)}
    </tr>
  )

  function formatCell(val) {
    if (val === 0) {
      return null;
    }

    return val.toFixed(2)
  }

  function ICon(props) {
    const row = props.row;

    if (row.type !== 'catgroup') {
      return null;
    }

    return (
      <span id={row.htmlId} onClick={props.onClick}>{row.isOpen ? getIcon("up") : getIcon("down")}</span>
    );
  }

}




function getIcon(name) {
  let fa_icon = "";
  if (name === "left") {
    fa_icon = "fa-caret-left";
  } else if (name === "right") {
    fa_icon = "fa-caret-right";
  } else if (name === "up") {
    fa_icon = "fa-caret-up";
  } else if (name === "down") {
    fa_icon = "fa-caret-down";
  }


  const icon = "fas " + fa_icon + " fa-fw";

  return <i className={icon}></i>;
}




function createCategoryGroups(simModel) {
  let groups = [];

  const len = simModel.categoryTypes.length;
  for (let c = 0; c < len; c++) {
    const cg = simModel.categoryTypes[c];

    let group = {
      catGroup: cg,
      showGroup: false,
      htmlId: 'catgroup_' + cg.code
    }

    groups.push(group);
  }

  return groups;
}


/**
 * Given a timespan and a grouping condition(year | period), return the list of column groups 
 * 
 * @param {*} timeline 
 * @param {number} groupType 1 == years, 2 == periods
 */
function createColumnGroups(simModel, timeline, groupType, isOpen = false) {
  const months = timeline.filter(t => t.isInPast === 0);

  let groups = []

  // groups are either years or periods, both numeric
  let cur_group_val = -1;
  let cur_group = {};

  let len = months.length;
  for (let i = 0; i < len; i++) {
    const m = months[i];

    let month_group = groupType === 1 ? m.year : m.periodIndex;
    if (month_group !== cur_group_val) {
      cur_group = {
        id: month_group,
        label: groupType === 1 ? m.year.toString() : simModel.periods[m.periodIndex].displayLabel,
        isOpen,

        htmlId: 'colgroup' + i.toString(),

        columns: [], // months in the group

        totals: [],

        miscTotal: 0, // optionaly used in some routines
        expPct: [], // just for percent experiment
      }

      cur_group_val = month_group;
      groups.push(cur_group);
    }

    cur_group.columns.push(m);
  }

  return groups;
}


function defineDataRows(catGroups, categories, acct) {
  let rows = [];

  defineRow(-1, 'Delinquent', 'access_sum', (s) => s.monthDelinquent);

  defineCatgroupRow(catGroups, categories, "INC");
  defineCatgroupRow(catGroups, categories, "EIT");
  if (acct !== null) {
    defineCatgroupRow(catGroups, categories, "TFA");
    defineRow(-1, 'Total earnings', 'access_sum', (s) => s.getTotalCredits(true));
  } else {
    defineRow(-1, 'Total earnings', 'access_sum', (s) => s.getTotalCredits(false));
  }

  defineCatgroupRow(catGroups, categories, "EXP");
  defineCatgroupRow(catGroups, categories, "CIT");
  if (acct !== null) {
    defineCatgroupRow(catGroups, categories, "TTA");
    defineRow(-1, 'Total expenses', 'access_sum', (s) => s.getTotalDebits(true));
  } else {
    defineRow(-1, 'Total expenses', 'access_sum', (s) => s.getTotalDebits(false));
  }

  if (acct === null) {
    defineRow(-1, 'Assets', 'access', (s) => s.liquidAssets);
    defineRow(-1, 'Debt', 'access', (s) => s.liabilities);
  }

  defineRow(-1, 'Balance', 'access', (s) => s.calendarEndBal);
  
  return rows;

  function defineCatgroupRow(catGroups, categories, code) {
    let group = catGroups.find(g => g.catGroup.code === code);

    defineRow(-1, group.catGroup.desc, 'catgroup', ((s) => s.groupTotals[group.catGroup.index]), group.showGroup, group.htmlId);
    if (group.showGroup) {
      showCategories(categories, group.catGroup.type);
    }

  }


  function defineRow(group, label, type, loadData, isOpen = true, htmlId = null) {
    let row = {
      type,
      label,
      htmlId: htmlId || type + rows.length.toString(),

      isOpen,

      loadData,

      data: []
    }

    rows.push(row);
  }


  function defineCatRow(cat, loadData) {
    defineRow(cat.group, cat.desc, 'cat', loadData);
  }


  function showCategories(categories, type) {
    for (let c = 0; c < categories.length; c++) {
      const category = categories[c];
      const cat = category.cat;
      const group = catGroups[cat.group].catGroup;

      if (group.type === type) {
        defineCatRow(cat, (s) => s.categories[category.idx]);
      }
    }
  }
}


function fillGrid(groups, rowDefs, acct) {
  let num_rows = rowDefs.length;


  for (let g = 0; g < groups.length; g++) {
    const group = groups[g];

    // First, initialize the totals for each group
    for (let r = 0; r < num_rows; r++) {
      group.totals.push(0);
    }

    for (let c = 0; c < group.columns.length; c++) {
      const month = group.columns[c];
      const accessor = acct === null ? month.monthTotals : month.monthSummaries[acct.index];
      //if ( accessor === undefined || accessor === null ) {
      //}

      for (let r = 0; r < num_rows; r++) {
        const row = rowDefs[r];

        let v = row.loadData(accessor);
        //if (v === undefined || v === null) {
        //}

        if (group.isOpen) {
          row.data.push(v);
        }

        // If its not a sum, then make the total equal to last value. This needs to be split out
        if (row.type === 'access') {
          group.totals[r] = v;
        } else {
          group.totals[r] += v;
        }
      }

      let v = 0; // debug
    }


    // Done the group, push the totals
    for (let r = 0; r < num_rows; r++) {
      const row = rowDefs[r];

      row.data.push(group.totals[r]);
    }

  } // for each group
}


/*
// https://www.freecodecamp.org/news/the-least-squares-regression-method-explained/
function calcLinearRegression(period) {
  const start = period.months[0].index;
  let bal = 0;
  const dd = period.months[0].monthTotals.getDifference(false);

  //let data = period.months.map( m => {const d = m.monthTotals.getDifference(false)/dd; bal += d; return {x: m.index - start, y: bal, b: m.monthTotals.getEndingBalance(false), d: d}} );
  let data = period.months.map( m => {const d = m.monthTotals.getDifference(false); bal += d; return {x: m.index, b: bal, y: m.monthTotals.getEndingBalance(false), d: d}} );

  let num_months = period.months.length;
  for ( let m=0; m<num_months; m++ ) {
    const month = period.months[m];


  }

  const sum = data.reduce((acc, pair) => ({
    x: acc.x + pair.x,
    //y: acc.y + ((pair.y/dd)),
    y: acc.y + pair.y,
  }), { x: 0, y: 0 });

  const average = {
    x: sum.x / num_months,
    y: sum.y / num_months,
  };

  const slopeDividend = data.reduce((acc, pair) => parseFloat(acc + ((pair.x - average.x) * (pair.y - average.y))), 0);
  const slopeDivisor = data.reduce((acc, pair) => parseFloat(acc + (pair.x - average.x) ** 2), 0);

  const slope = slopeDivisor !== 0
    ? parseFloat((slopeDividend / slopeDivisor).toFixed(2))
    : 0;

  const coeficient = parseFloat(
    (-(slope * average.x) + average.y).toFixed(2),
  );

  period.score = slope + ' : ' + coeficient;

//  const sum = currentData.pairs.reduce((acc, pair) => ({
//    x: acc.x + pair.x,
//    y: acc.y + pair.y,
//  }), { x: 0, y: 0 });

  let y=0;
}




  function onDownload(event) {
    event.preventDefault();

    let data = makeGrid(results);
    let csv = makeCSV(data);

    const element = document.createElement("a");
    const file = new Blob([csv], { type: 'text/csv' });
    element.href = URL.createObjectURL(file);
    element.download = "myFile.csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

*/

